import { useDispatch, useSelector } from "react-redux"

import useFetch from "../../../hook/useFetch"
import { Fragment, useEffect, useState } from "react"
import { userActions } from "../../../store/user-slice"
import { notificationActions } from "../../../store/notification-slice"
import useIsMobile from '../../../hook/useIsMobile';

import DesktopComponent from "./datatable/DesktopComponent"
import MobileComponent from './datatable/MobileComponent';
import { useLocation, useParams } from "react-router-dom"
import EditUser from "./EditUser"
import useFilter from "../../../hook/useFilter"
import Skeleton from "react-loading-skeleton"

export default function Users() {


    const { get } = useFetch()
    
    const [users, setUsers] = useState()
    let dispatch = useDispatch()

    let location = useLocation()


    const { convertToArray } = useFilter()

    const { id } = useParams();


    const fetchUsers = () => {
        setUsers(null)
        dispatch(userActions.resetUsers())
       
        get('/admin/users', null, (data) => {
            dispatch(notificationActions.setNotification({
                message: data,
                status: false
            }))
        }, (data) => {
            data = convertToArray(data)
            setUsers(data)
            dispatch(userActions.setUsers(data))

        })
    }

    useEffect(() => {

        fetchUsers()


    }, [])


    useEffect(() => {
        
        if (location.state && location.state.refetch) {
            
            fetchUsers()

        }
    }, [location.state])

    if (!users) {
        return <Skeleton count={50} />
    }

    if (id) {

        return <EditUser id={id} />
    }



    return <Fragment>{users && <Datatable users={users} />}</Fragment>
}


const Datatable = () => {


    const { isMobile } = useIsMobile()


    return <div className="rso-pages card shadow  bg-white rounded p-3 m-0">{isMobile ? <MobileComponent /> : <DesktopComponent />}</div>

}




